import { Box, Button, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { ReceiverDetailsContext } from "../../contexts/receiverDetailsContext";

interface BlockedAccountProps {
  userName: string;
  onDeleteClick: any;
  onUnblockClick: any;
  updateFooterHeight: any;
}

const BlockedAccount = ({ userName, onDeleteClick, onUnblockClick, updateFooterHeight }: BlockedAccountProps) => {
  const { receiverDetails } = useContext<any>(ReceiverDetailsContext);
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const mac: any = document.getElementsByClassName("messageAcceptContainer")[0];
      if (mac) {
        updateFooterHeight(mac.offsetHeight);
      }
    });
    if (document.getElementsByClassName("messageAcceptContainer")[0]) {
      const config: any = { attributes: true, childList: true, characterData: true };
      resizeObserver.observe(document.getElementsByClassName("messageAcceptContainer")[0], config);
    }
    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box className="messageAcceptContainer mar-t-8 w-per-100 display-flex flex-direction-column bg-true-white mdc-typography--border-top">
      <Typography className="text-primary ft-wt-500 text-align-c" variant="subtitle1">
        {receiverDetails.entityType === 1 ? "You've blocked this account" : "You've blocked this store"}
      </Typography>
      <Typography className="text-secondary mar-t-12 text-align-c" component="div" variant="body2">
        You can't message {userName} until you unblock them.
      </Typography>
      <Box className="flex flex-direction-row w-per-100 display-flex-justify-center mar-t-16">
        <Button variant="outlined" className="MuiButtonBase-cancel mar-r-8" sx={{ textTransform: "capitalize" }} onClick={onDeleteClick}>
          Delete
        </Button>
        <Button variant="contained" sx={{ textTransform: "capitalize" }} onClick={onUnblockClick}>
          Unblock
        </Button>
      </Box>
    </Box>
  );
};

export default BlockedAccount;
